var EventListener = /** @class */ (function () {
    function EventListener(element) {
        this.listeners = {};
        this.element = element;
    }
    /**
     * to register listener
     * @param eventName event name
     * @param callback handler function
     */
    EventListener.prototype.addListener = function (eventName, callback) {
        if (this.element) {
            this.removeListener(eventName);
            this.element.addEventListener(eventName, callback);
            this.listeners[eventName] = callback;
        }
    };
    /**
     * to remove listener
     * @param eventName event name
     */
    EventListener.prototype.removeListener = function (eventName) {
        if (this.element && this.listeners[eventName]) {
            this.element.removeEventListener(eventName, this.listeners[eventName]);
            delete this.listeners[eventName];
        }
    };
    /**
     * to remove all listener
     */
    EventListener.prototype.removeAllListeners = function () {
        for (var _i = 0, _a = Object.keys(this.listeners); _i < _a.length; _i++) {
            var eventListener = _a[_i];
            this.removeListener(eventListener);
        }
    };
    return EventListener;
}());
export { EventListener };
//# sourceMappingURL=event-listener.js.map